import { createFileRoute } from '@tanstack/react-router';
import { ProposeSemanticModelPage } from '@/features/metric-hub/semantic-models/ProposeSemanticModelPage';

/**
 * Edit-existing-draft route for semantic models. Renders
 * `<ProposeSemanticModelPage>` in EDIT mode (`editingDraftId` set) so the
 * author can mutate their in-flight draft via PATCH and re-submit — the
 * author lands here after a reviewer says "request changes". This path never
 * hits the one-in-flight guard on `POST /drafts` (which is what blocked
 * editing a draft via the propose-version page).
 *
 * URL: `/metric-hub/semantic-models/<name>/drafts/<draftId>/edit`. Sibling of
 * the propose-version route; `$name_` opts out of the `$name` detail layout.
 */
export const Route = createFileRoute(
  '/_authed/metric-hub/semantic-models/$name_/drafts/$draftId/edit',
)({
  component: RouteComponent,
});

function RouteComponent() {
  const { name, draftId } = Route.useParams();
  return <ProposeSemanticModelPage fromName={name} editingDraftId={draftId} />;
}
